import React, { useRef } from 'react';

import { useTheme } from '@mui/material/styles';

import AppTextField, {
  IAppTextFieldProps,
} from '../app-text-field/AppTextField';
import { useStyles } from './AppStandardTextField.styles';

export interface IAppStandardTextFieldProps extends IAppTextFieldProps {
  selectOnClick?: boolean;
  slotProps?: any;
  onFocus?: () => void;
  onBlur?: () => void;
}

export default function AppStandardTextField(
  props: IAppStandardTextFieldProps,
) {
  const { placeholder, label, selectOnClick, onFocus, ...textFieldProps } =
    props;

  const { classes } = useStyles({ fullWidth: props.fullWidth });
  const inputRef = useRef(null);

  return (
    <AppTextField
      {...textFieldProps}
      inputRef={inputRef}
      type={textFieldProps.type || 'text'}
      label={null}
      classes={classes}
      placeholder={placeholder || (label as string)}
      onFocus={() => {
        selectOnClick && inputRef.current?.select();
        onFocus && onFocus();
      }}
    />
  );
}
